import type { BoosterTypeController } from './types';
import type { GameAreaController } from '../GameAreaController';
import { BoosterRedrawModel } from '../../models/boosters/BoosterRedrawModel';

export class BoosterRedrawController implements BoosterTypeController {
  public readonly isInstant = true;

  constructor(private readonly gameAreaController: GameAreaController) {}

  public canExecute(): boolean {
    return true;
  }

  public execute(onComplete: (success: boolean) => void): this {
    new BoosterRedrawModel(this.gameAreaController.trayModel).execute();
    onComplete(true);
    return this;
  }

  public cancel(): void {}
}
